import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SKUSearchViewModel } from '../../../models/search-result.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { Subscription } from 'rxjs';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../../services/common.service';
import { NgProgressService } from '../../../services/ngProgress.service';

@Component({
    selector: 'app-cart-search',
    templateUrl: './cart-search.component.html',
    styleUrls: ['./cart-search.component.css']
})
export class CartSearchComponent implements OnInit, OnDestroy {
    setFullWindow = false;
    title = 'SEARCH RESULT';
    searchKeyWord: string;
    cartSearchResult: SKUSearchViewModel[] = [];
    subscriptionActiveRouter: Subscription;
    subscriptionshoppingCartService: Subscription;


    constructor(
        private activeRouter: ActivatedRoute,
        private shoppingCartService: ShoppingCartService,
        private router: Router,
        public ngProgress: NgProgressService,
        private commonService: CommonService
    ) { }

    ngOnInit() {

        this.ngProgress.start();

        $('.page-contents').animate({ scrollLeft: ($('#levelOne').width() + $('#myCart').width()) }, 400);

        this.subscriptionActiveRouter = this.activeRouter.url.subscribe(value => {
            value.length > 1 ? this.searchKeyWord = value[1].path : "";
        });

        this.subscriptionshoppingCartService = this.shoppingCartService.getCartSearchResult(this.searchKeyWord).subscribe(
            (data: SKUSearchViewModel[]) => {
                this.ngProgress.done();
                this.cartSearchResult = data;
            },
            (error: any) => console.info(error));

    }

    close() { this.ngProgress.done();
        $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
        this.router.navigateByUrl('/myCarts');
    }

    ngOnDestroy(): void {
        if (this.subscriptionActiveRouter) {
            this.subscriptionActiveRouter.unsubscribe();
        }
        if (this.subscriptionshoppingCartService) {
            this.subscriptionshoppingCartService.unsubscribe();
        }
    }

}
